export default "__VITE_PUBLIC_ASSET__b321a5c9__"